import React from 'react';
import { PAGE_PROVIDERS } from '../utils/pageProvider';

/** Provider choice that belongs to one page, not the old Models tab. */
export default function ProviderSelect({ value, onChange, style }) {
  return (
    <label style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 13, fontWeight: 600, color: 'var(--text-secondary)' }}>
      Provider
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        title="Which AI provider this page uses"
        style={{
          padding: '6px 10px',
          border: '1px solid var(--border-color, #ccc)',
          borderRadius: 6,
          background: 'var(--select-bg, #fff)',
          color: 'var(--text-primary)',
          fontSize: 13,
          ...style
        }}
      >
        {PAGE_PROVIDERS.map((p) => (
          <option key={p.value} value={p.value}>{p.label}</option>
        ))}
      </select>
    </label>
  );
}
